import { Box } from "@mui/material";
import styled from "styled-components";

export const SidebarLowerContentContainer = styled(Box)`
  display: flex;
  flex-direction: ${(props) =>
    props?.$isSidebarOpened ? "row-reverse" : "column-reverse"};
  gap: 8px;
`;
